export const WAITLIST_FAQ_ITEMS = [
  {
    q: "When will EZSpot launch in my city?",
    a: "We're rolling out city by city based on driver and host demand. Joining the waitlist tells us where to launch next, and we'll email you the moment spots are bookable in your area.",
  },
  {
    q: "Do waitlist members get early access?",
    a: "Yes — waitlist members are the first invited when we open a new city, before any public launch. You'll get a heads-up by email with a link to start booking right away.",
  },
  {
    q: "Is there a cost to join the waitlist?",
    a: "No. The waitlist is completely free and there's no commitment. You only pay when you book a spot once EZSpot is live in your area.",
  },
  {
    q: "What information do you collect?",
    a: "Just your name, email, and an optional phone number so we can let you know when we launch. We don't share your details with third parties and you can unsubscribe anytime.",
  },
  {
    q: "I want to list my parking spot — should I still join?",
    a: "If you want to host, head to the Hosts page to start an application — you don't need the waitlist. The waitlist is mainly for drivers who want first access once we launch.",
  },
] as const;
